import { createAsyncAction } from 'redux-promise-middleware-actions';
import api from '../Api/apiIS';
import { getActionTypesResult } from '../utils';

export const devicesConstants = {
    DEVICES_LOADED: 'DEVICES_LOADED',
    DEVICES_CLEARED: 'DEVICES_CLEARED',
    DEVICE_CREATED: 'DEVICE_CREATED',
    BULK_DEVICE_CREATED: 'BULK_DEVICE_CREATED',
    DEVICE_UPDATED: 'DEVICE_UPDATED',
    DEVICE_DELETED: 'DEVICE_DELETED',
    DEVICE_ASSIGNED: 'DEVICE_ASSIGNED',
    DEVICE_UNASSIGNED: 'DEVICE_UNASSIGNED',
    DEVICE_GROUP_UPDATED: 'DEVICE_GROUP_UPDATED',
    DEVICE_PROFILE_INFO_LOADED: 'DEVICE_PROFILE_INFO_LOADED',
    DEVICES_GROUPED_UNASSIGNED: 'DEVICES_GROUPED_UNASSIGNED',
    DEVICE_CHECK_PRIMARY_STATUS: 'DEVICE_CHECK_PRIMARY_STATUS',
    RESERVE_CREATED: 'RESERVE_CREATED',
    RESERVE_UPDATED: 'RESERVE_UPDATED',
    RESERVE_DELETED: 'RESERVE_DELETED',
};

export const devicesFulfilledConstants = getActionTypesResult(devicesConstants, '_FULFILLED');
export const devicesPendingConstants = getActionTypesResult(devicesConstants, '_PENDING');
export const devicesRejectedConstants = getActionTypesResult(devicesConstants, '_REJECTED');

export const clearDevices = () => ({ type: devicesConstants.DEVICES_CLEARED });

export const fetchDevices = createAsyncAction(devicesConstants.DEVICES_LOADED, query =>
    api.get('devices', { params: query, paramsSerializer: { indexes: null } }).then(res => res.data)
);

export const saveDevice = createAsyncAction(devicesConstants.DEVICE_CREATED, device =>
    api.post('devices', device).then(res => res.data)
);

export const saveBulkDevices = createAsyncAction(devicesConstants.BULK_DEVICE_CREATED, device =>
    api.post('devices/bulkCreate', device).then(res => res.data)
);

export const updateDevice = createAsyncAction(devicesConstants.DEVICE_UPDATED, (deviceId, device) =>
    api.put(`devices/${deviceId}`, device).then(res => res.data)
);

export const groupUpdateDevice = createAsyncAction(devicesConstants.DEVICE_GROUP_UPDATED, data =>
    api.put(`devices/bulkUpdate`, data).then(res => res.data)
);

export const deleteDevice = createAsyncAction(devicesConstants.DEVICE_DELETED, deviceId =>
    api.delete(`devices/${deviceId}`).then(res => res.data)
);

export const checkPrimaryChangeStatus = createAsyncAction(devicesConstants.DEVICE_CHECK_PRIMARY_STATUS, deviceId =>
    api.get(`devices/${deviceId}/primaryDeviceInfo`).then(res => res.data)
);

export const createReserveDevice = createAsyncAction(devicesConstants.RESERVE_CREATED, data =>
    api.post(`devices/reservation`, data).then(res => res.data)
);

export const updateReserveDevice = createAsyncAction(devicesConstants.RESERVE_UPDATED, data =>
    api.put(`devices/reservation`, data).then(res => res.data)
);

export const deleteReserveDevice = createAsyncAction(devicesConstants.RESERVE_DELETED, id =>
    api.delete(`devices/reservation/${id}`).then(res => res.data)
);

export const assignDevice = createAsyncAction(devicesConstants.DEVICE_ASSIGNED, (deviceId, data) =>
    api.put(`devices/${deviceId}/assign`, data).then(res => res.data)
);

export const unassignDevice = createAsyncAction(devicesConstants.DEVICE_UNASSIGNED, (deviceId, data) =>
    api.put(`devices/${deviceId}/unassign`, data).then(res => res.data)
);

export const gropedUnassignDevice = createAsyncAction(devicesConstants.DEVICES_GROUPED_UNASSIGNED, data =>
    api.put(`devices/groupedUnassign`, data).then(res => res.data)
);

export const fetchDeviceProfileInfo = createAsyncAction(
    devicesConstants.DEVICE_PROFILE_INFO_LOADED,
    deviceId => api
        .get(`devices/${deviceId}/info`)
        .then(res => ({ data: res.data, deviceId })),
    deviceId => deviceId
);
